import axios from 'axios';
import localforage from 'localforage';

// Erstelle Axios Instance
const axiosInstance = axios.create({
  baseURL: 'https://lager-app-api.sunrise-avengers.ch',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request Interceptor - Fügt automatisch den Token hinzu
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      // Hole Token aus localforage
      const token = await localforage.getItem('token');
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      
      // Don't set Content-Type for FormData - let browser handle it
      if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
      }
      
      return config;
    } catch (error) {
      console.error('❌ Error getting token:', error);
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor - Behandelt 401 Errors
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token ist abgelaufen oder ungültig
      console.error('❌ Unauthorized - redirecting to login');
      
      // Lösche Token
      await localforage.removeItem('token');
      
      // Redirect zu Login
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
